import { jsx, jsxs } from "react/jsx-runtime";
import { lazy, memo } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
import styles from "./FilterItem.module.scss.js";
const CheckboxGroup = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/Checkbox").then((module) => ({ default: module.Checkbox.Group }))
);
const ColorPicker = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/ColorPicker").then((module) => ({ default: module.ColorPicker }))
);
const DuoColorPicker = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/DuoColorPicker").then((module) => ({ default: module.DuoColorPicker }))
);
const Select = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/Select").then((module) => ({ default: module.Select }))
);
const Slider = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/Slider").then((module) => ({ default: module.Slider }))
);
const RangeSlider = lazy(
  () => import("@perxis-auto/ui-kit/lib/components/RangeSlider").then((module) => ({ default: module.RangeSlider }))
);
const FilterModels = lazy(() => import("./filterModels/index.js").then((module) => ({ default: module.FilterModels })));
const FilterLocation = lazy(() => import("./filterLocation/index.js").then((module) => ({ default: module.FilterLocation })));
const FilterOptions = lazy(() => import("./filterOptions/index.js").then((module) => ({ default: module.FilterOptions })));
const renderFilterComponent = (item) => {
  const { props } = item;
  switch (item.type) {
    case ConstructorWidgetEnum.FilterCheckboxGroup: {
      return /* @__PURE__ */ jsx(CheckboxGroup, { ...props });
    }
    case ConstructorWidgetEnum.FilterModels: {
      return /* @__PURE__ */ jsx(FilterModels, { ...props });
    }
    case ConstructorWidgetEnum.FilterLocation: {
      return /* @__PURE__ */ jsx(FilterLocation, { ...props });
    }
    case ConstructorWidgetEnum.FilterColorPicker: {
      return /* @__PURE__ */ jsx(ColorPicker, { ...props });
    }
    case ConstructorWidgetEnum.FilterDuoColorPicker: {
      return /* @__PURE__ */ jsx(DuoColorPicker, { ...props });
    }
    case ConstructorWidgetEnum.FilterSelect: {
      return /* @__PURE__ */ jsx(Select, { allowClear: true, ...props });
    }
    case ConstructorWidgetEnum.FilterMultipleSelect: {
      return /* @__PURE__ */ jsx(Select, { mode: "multiple", ...props });
    }
    case ConstructorWidgetEnum.FilterSlider: {
      return /* @__PURE__ */ jsx(Slider, { ...props });
    }
    case ConstructorWidgetEnum.FilterRangeSlider: {
      return /* @__PURE__ */ jsx(RangeSlider, { ...props });
    }
    case ConstructorWidgetEnum.FilterOptions: {
      return /* @__PURE__ */ jsx(FilterOptions, { ...props });
    }
    default:
      return null;
  }
};
const FilterItem = memo(function FilterItem2({ isDependencyFulfilled, items }) {
  if (!items.length) {
    return null;
  }
  if (!isDependencyFulfilled) {
    return /* @__PURE__ */ jsx(Typography.Paragraph, { level: "small", color: "dark-light", children: items[0].dependencyText });
  }
  if (items.length < 2) {
    return renderFilterComponent(items[0]);
  }
  return /* @__PURE__ */ jsx(Row, { gutter: [0, "vertical-sky"], className: styles.filterItemGroup, children: items.map((item, index, self) => {
    [...self];
    return /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-blue"], children: [
      !!item.groupTitle && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "darkest", className: styles.filterItemGroupTitle, children: item.groupTitle }) }),
      /* @__PURE__ */ jsx(Col, { span: 24, children: renderFilterComponent(item) })
    ] }) }, `${item.key}-${String(index)}`);
  }) });
});
export {
  FilterItem
};
